<template>
  <div class="geocoder-autocomplete" :class="{ 'is-full-display': isFullDisplay }">
    <AutoComplete
      v-model="query"
      :suggestions="queryResults"
      option-label="title"
      :placeholder="$t('Search address using Google Maps...')"
      @complete="searchChange"
      @item-select="select"
      autocomplete="off"
    />
  </div>
</template>

<script>
import AutoComplete from "primevue/autocomplete";
import {TransformInteractionState} from "@/js/Map/interaction/abstract-transform";

export default {
  name: "MapGeocoder",
  components: {AutoComplete},
  props: {
    mapController: {
      type: Object,
      required: true
    },
    addOnMap: {
      type: Boolean,
      default: true
    },
    isFullDisplay: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      providers: [{id: 'google', name: 'Google'}, {id: 'mapbox', name: 'Mapbox'}],
      provider: 'google',
      query: '',
      queryResults: [],
    }
  },
  methods: {
    searchChange(event) {
      this.query = event.query;
      let query = event.query;

      if (query.trim() === '') {
        return;
      }
      let bounds = this.mapController.mapInstance.getBounds();
      this.$store.dispatch('googleGeocodeSearch', {
        query: {
          address: query,
          take: 20
        },
        headers: {
          "x-access-token": this.mapController?.configuration?.accessToken,
        }
      }).then(response => {
        this.queryResults = [...response];
        this.$forceUpdate();
      }).catch(error => {
        this.mapController.configuration.toastProvider({summary: 'Error', detail: this.$t(error), severity: 'error'})
      })
    },

    select(event) {
      this.$store.dispatch('googleGeocodePlace', {
        query: {placeId: event.value.placeId},
        headers: {
          "x-access-token": this.mapController?.configuration?.accessToken,
        }
      }).then(response => {
        if (this.addOnMap) {
          let feature = {
            id: event.value.placeId,
            type: 'Feature',
            geometry: {type: 'Point', coordinates: [response.longitude, response.latitude]},
            properties: {id: event.value.placeId},
          };
          this.mapController.interaction.addTmpGeometries([feature]);
          let state = new TransformInteractionState([feature], false);
          this.mapController.interaction.mode.changeInteraction('point_transform_translate', state)
        }
        this.mapController.mapInstance.fitBounds(
          response.bounds,
          {duration: 0}
        );

        this.mapController.jumpToLayer = false;

      }).catch(error => {
        console.error(error);
        this.mapController.configuration.toastProvider({summary: 'Error', detail: this.$t(error), severity: 'error'})
      })
    },
  }
}
</script>

<style lang="scss">
.geocoder-autocomplete {
  width: 100% !important;
  .p-autocomplete.p-component.p-inputwrapper {
    width: 100% !important;
    flex: 0 0 100% !important;
    input {
      width: 100% !important;
      flex: 0 0 100% !important;
    }
  }
}
.geocoder-autocomplete.is-full-display {
  border: 1px solid var(--surface-400);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  margin-bottom: 2px;
  display: flex;

  .p-autocomplete.p-component.p-inputwrapper {
    flex: 1;

    input {
      width: 100% !important;
      height: 50px !important;
      font-size: larger !important;
      background: var(--surface-0) !important;
      border: 0 !important;
    }
  }

  &:has(input:focus) {
    border: 1px solid var(--primary-color);
  }
}
</style>
